import invert from 'lodash/invert';
import { getInvitationStatus } from '../microservices/refer-a-friend';
import { storageGet, storageSet } from './storage';

export const suffixMap = {
    facebook: 'F',
    whatsapp: 'W',
    facebookMessenger: 'C',
    link: 'L',
    email: 'E',
    sms: 'M',
} as const;

export const STATUS = {
    REGISTERED: 'registered',
    DEPOSITED: 'deposited',
    PENDING: 'pending',
    REWARDED: 'rewarded',
};

export function getCodeWithoutProvider(code) {
    return code.split('-')[0];
}

export function getCodeProvider(code) {
    const providerSuffix = code.split('-')[1];
    return invert(suffixMap)[providerSuffix];
}

export const PARTICIPANT_STATUS = {
    ENABLED: 'enabled',
    REQUEST: 'request',
    DISABLED: 'disabled',
    REJECTED: 'rejected',
};

export async function getRafBannerMessageProperties(userId) {
    const isReferredUser = storageGet('referred_user');

    if (isReferredUser && !Boolean(isReferredUser)) {
        return null;
    }

    const invitationStatus = await getInvitationStatus(userId);
    storageSet('referred_user', invitationStatus.referred_user);

    return invitationStatus.display_banner && invitationStatus.referred_user
        ? invitationStatus.banner_properties
        : null;
}
